import { render, staticRenderFns } from "./disc.vue?vue&type=template&id=32d999e0&scoped=true"
import script from "./disc.vue?vue&type=script&lang=js"
export * from "./disc.vue?vue&type=script&lang=js"
import style0 from "./disc.vue?vue&type=style&index=0&id=32d999e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d999e0",
  null
  
)

export default component.exports